
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { LocaleItemProps } from ".";
import { loading, endLoading } from "store/locale";

interface ApiLocaleRemoveInputProps {
    ids: number[]
}

type ApiLocaleRemoveOutputProps = OutputBaseProps<{ item: LocaleItemProps; }>

export const apiLocaleRemove = async (data: ApiLocaleRemoveInputProps) => {
    store.dispatch(loading());
    const res = (await axios.delete<ApiLocaleRemoveOutputProps>("/api/locale/remove", { data }))
        .data;
    store.dispatch(endLoading());
    return res;
};